import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import BuildersLogo from "@components/BuildersLogo";
import HeadlessButton from "@components/Button";
import LanguageToggle from "@components/constant_components/LanguageToggle";
export function Landing(): JSX.Element {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  function handleLogin(type: number) {
    if (type === 1) {
      navigate("/login/user");
    } else {
      navigate("/login/admin");
    }
  }
  return (
    <div className="tw-flex tw-flex-col tw-align-center tw-justify-center tw-h-[100vh] tw-relative">
      {/* Language Toggle in the Top-Right Corner */}
      <div className="tw-absolute tw-top-4 tw-right-4">
        <LanguageToggle />
      </div>

      <div className="tw-flex tw-justify-center tw-mb-20">
        <BuildersLogo className="tw-h-[150px]" />
      </div>
      <div className="tw-flex tw-align-center tw-justify-center">
        <HeadlessButton
          type="submit"
          disabled={false}
          className={`${
            i18n.language === "es" ? "tw-min-w-[330px]" : "tw-min-w-[200px]"
          }  tw-h-[50px] tw-px-8 tw-py-[0.5em] tw-text-2xl tw-border tw-border-primary tw-rounded-[0.25em] tw-bg-primary-blue tw-text-white tw-font-light tw-mb-6 tw-flex tw-items-center tw-justify-center`}
          onClick={() => handleLogin(1)}
        >
          {t("landing.userLogin")}
        </HeadlessButton>
      </div>
      <div className="tw-flex tw-align-center tw-justify-center">
        <HeadlessButton
          type="submit"
          disabled={false}
          className={`${
            i18n.language === "es" ? "tw-min-w-[330px]" : "tw-min-w-[200px]"
          }  tw-h-[50px] tw-px-8 tw-py-[0.5em] tw-text-2xl tw-border tw-border-primary tw-rounded-[0.25em] tw-bg-primary-blue tw-text-white tw-font-light tw-mb-6 tw-flex tw-items-center tw-justify-center`}
          onClick={() => handleLogin(2)}
        >
          {t("landing.adminLogin")}
        </HeadlessButton>
      </div>
    </div>
  );
}
